import { sanitizeString } from '../../lib/helpers';
import { RESERVATION_AMT } from '../../constants';

export const mapValuesToBackend = (values, vehicleData, vehicleImage, token) => {
  let data = {
    "pricingRequests": {
      "driveAwayPrice": values.driveAwayPrice,
      "monthlyRepayment": values.monthlyRepayment,
      "changeOverPrice": values.changeOverPrice,
      "otherRequests": values.otherRequests
    },
    "customer": {
      "firstName": values.firstName,
      "lastName": values.lastName,
      "email": values.email,
      "mobile": values.mobile,
      "postcode": values.postcode
    },
    "payment": {
      "paymentType": "CreditCard",
      "chargeToken": token,
      "amount": RESERVATION_AMT
    },
    "tradeIn": values.tradeIn === 'true',
    "contactFinance": values.contactFinance === 'true',
    "dealer": vehicleData?.dealer?.id,
    "model": vehicleData?.symbolicCarline?.description,
    "modelCode": vehicleData?.modelCode?.code,
    "engine": vehicleData?.modelCode?.description || "missing",
    "modelYear": vehicleData?.modelYear,
    "vin": vehicleData?.vin,
    "cost": "",
    "optIn": !!values.optIn,
    "marketingOptins": !!values.marketingOptins,
    "commissionNumber": vehicleData?.commissionNumber,
    "imageUrl": vehicleImage ? vehicleImage.url : "",
    "vehicleId": vehicleData?.id,
    "usedCar": false,
    "usedMileage": null
  }
  if (vehicleData?.typedPrices) {
    let price = vehicleData.typedPrices.find((p) => { return p.type === "retail"; });
    if (price) {
      data.cost = price.amount;
    }
  }
  if (vehicleData?.used && vehicleData?.used?.mileage > 0) {
      data.usedCar = true;
      data.usedMileage = `${vehicleData.used.mileageFormatted}${vehicleData.used.mileageUnit}`;
  }
  if (data.tradeIn) {
    data.tradeInDetails = {
      "redbookcode": values.redbookcode,
      "regoNumber": values.tradeRego,
      "regoState": values.tradeState,
      "make": values.tradeMake,
      "model": values.tradeModel,
      "year": values.tradeYear,
      "kilometers": values.tradeKms,
      "hasFinance": values.tradeHasFinance === 'yes',
    }
  }
  return data;
}

export const mapValuesToGTM = (values, vehicleData) => {
  let data = {
    "driveAwayPrice": values.driveAwayPrice,
    "monthlyRepayment": values.monthlyRepayment,
    "changeOverPrice": values.changeOverPrice,
    "otherRequests": String.prototype.trim(sanitizeString(values.otherRequests)),
    "firstName": values.firstName,
    "lastName": values.lastName,
    "email": values.email,
    "mobile": values.mobile,
    "postcode": values.postcode,
    "tradeIn": values.tradeIn === 'true',
    "contactFinance": values.contactFinance === 'true',
    "dealer": vehicleData?.dealer?.id,
    "model": vehicleData?.symbolicCarline?.description,
    "modelCode": vehicleData?.modelCode?.code,
    "engine": vehicleData?.modelCode?.description,
    "modelYear": vehicleData?.modelYear,
    "cost": "",
    "optIn": values.optIn,
    "commissionNumber": vehicleData?.commissionNumber,
    "vehicleId": vehicleData?.id,
    "usedCar": false,
    "usedMileage": null
  };
  if (vehicleData?.typedPrices) {
    let price = vehicleData.typedPrices.find((p) => { return p.type === "retail"; });
    if (price) {
      data.cost = price.amount;
    }
  }
  if (vehicleData?.used && vehicleData?.used?.mileage > 0) {
      data.usedCar = true;
      data.usedMileage = `${vehicleData.used.mileageFormatted}${vehicleData.used.mileageUnit}`;
  }
  if (data.tradeIn) {
    data.tradeInMake = values.tradeMake;
    data.tradeInModel = values.tradeModel;
    data.tradeInYear = values.tradeYear;
    data.tradeInKms = values.tradeKms;
    data.tradeInHasFinance = values.tradeHasFinance === 'yes';
  }
  return data;
}

export const flattenBackendErrors = (nestedErrors) => {
  let {pricingRequests, customer, payment, tradeInDetails, ...rest} = nestedErrors;
  let errors = {...rest};
  if (pricingRequests && Object.keys(pricingRequests).length) {
    errors = Object.assign(errors, pricingRequests);
  }
  if (customer && Object.keys(customer).length) {
    errors = Object.assign(errors, customer);
  }
  if (payment && Object.keys(payment).length) {
    errors = Object.assign(errors, payment);
  }
  if (tradeInDetails && Object.keys(tradeInDetails).length) {
    errors = Object.assign(errors, tradeInDetails);
  }
  return errors;
}
